import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Button, Container} from 'react-bootstrap';
import Select from 'react-select';
import MaterialTable from 'material-table';
import {Send, AssignmentReturn as Assignment, Edit, History} from '@material-ui/icons';
import { useHistory, useParams, NavLink } from 'react-router-dom';

import moment from 'moment';
import {
  localization, mapFilesForModal, modifyDefaultOptions, objectToCols, options, styledCellSticky, tableIconsModified,
} from '../../helpers/table';
import {
  makeUID, mBStyles, styledTable, styledTableHeading, tableIcons, years, YesLookup, yseLookupFiltering,
} from '../../helpers';
import ReportStatusBadge from '../ReportStatusBadge';
import useAPI from '../../hooks/useAPI';
import { canEdit, canSendForApprove, canSendForRevision } from './reportRegisterDataService';
import useUserContext from '../../hooks/useUserContext';
import SendForRevisionModal from '../ProjectReportTabs/SendForRevisionModal';
import {
  filterProjStatus,
  filterReportStatus,
  statusKeys,
  statusKeys as statusReport,
  statusLabels
} from '../../helpers/projReportHelper';
import DownloadLink from '../common/DownloadLink';
import {
  getStrategyPermissions, isAdmin, isAdminRead, isAdminReadRestricted, isProjectAdmin,
} from '../../services/rolesSvc';
import LoadingTable from '../table/LoadingTable';
import ProjRegisterDataAction from "../common/Actions/ProjRegisterDataAction";
import style from './style.module.less'
import FileTableComponent from "../FileTableIcon/FileTableComponent";
import ModalDescription from "../common/ModalDescription";
import {MuiThemeProvider} from "@material-ui/core";
import {ReportRegisterTabTheme} from "../../../style/themes";
import {Fab} from "react-tiny-fab";
import SelectionFab from "./SelectionFab";
import ReactDOM from "react-dom";
import ModalExpertDecision from "../UI/modals/ModalExpertDecision";
import useToast from "../../hooks/useToast";
import ModalCloseProj from "../UI/modals/ModalCloseProj";
import {
  closeProject, editCloseDataProject,
  editExpertDecision,
  getReportByProjId,
  saveExpertDecision
} from "../../requests/ProjectRequest/projectRequest";
import {status as PS, status_ru as PS_Labels} from "../../helpers/passport";
import {statusKeys as RS} from '../../helpers/projReportHelper'
import StatusBadge from "../common/StatusBadge";
let modifiedYears = [
  ...years.map(function(val) {
  return {value: val, label: val};
})];

const defaultYear = Number(DEFAULT_YEAR_WEBPACK_REPORT);

function IconSendApprove({ disabled }) {
  return <Send style={{ color: !disabled ? '#ffc107' : undefined }} color={disabled ? 'disabled' : undefined} />;
}
function IconSendRevision({ disabled }) {
  return <Assignment color={disabled ? 'disabled' : 'error'} />;
}
function IconEdit({ disabled }) {
  return <Edit style={{ color: !disabled ? '#ffc107' : undefined }} color={disabled ? 'disabled' : undefined} />;
}

export default function ReportRegisterTab(props) {
  const { stratId } = useParams();
  const history = useHistory();
  const tableRef = useRef(null)
  const addToast = useToast()

  const DEFAULT_DECISION = {
    mark: '',
    isApproved: true,
    recommendations: undefined,
    protocol: undefined,
    decisionDate: undefined,
    decisionFiles: []
  };
  const DEFAULT_CLOSE_DATA = {
    closedOn: undefined,
    closeFiles: []
  };

  const [tableKey, setTableKey] = useState(makeUID(5));
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [revisionModalReportId, setRevisionModalReportId] = useState(null);
  const [currentYear, setCurrentYear] = useState({ value: defaultYear, label: defaultYear });
  const [approvedProjectsInCurrentYear,setApprovedProjectsInCurrentYear] = useState(null)
  const [filesModalOpen, setFilesModalOpen] = useState(null)
  const [selectedRows, setSelectedRows] = useState({})
  const [modalName, setModalName] = useState('');
  const [currReport,setCurrReport] = useState(null)

  const [decision, setDecision] = useState(DEFAULT_DECISION);
  const [closeData,setCloseData] = useState(DEFAULT_CLOSE_DATA)

  const api = useAPI();
  const userCtx = useUserContext();

  const filtersHead = useMemo(() => data.reduce((acc, item) => {
    if (item.head) return {...acc, [item.head.id]: item.head.fullName};
    return acc;
  }, {}), [data]);

  //todo: perms

  const canDecide = useMemo(() => !!isAdmin(userCtx), [userCtx])
  const canViewReport = useMemo(() => {
    const stratProjIds = data ? data.map((p) => p.id) : [];
    // отчет по уникальным результатам могут видеть:
    // ПО/админы
    return isAdminRead(userCtx)
        // пользователи данного СП с ролями, позволяющими редактировать отчет проектов
        || getStrategyPermissions(userCtx, parseInt(stratId)).canWrite
        // пользователи проектов...
        || userCtx.perms.includes('projs')
        // ...данного СП с ролями, позволяющими редактировать отчет проектов
          && stratProjIds.find((id) => userCtx.mine.projs.find((p) => p.projId === id && ['admin', 'head'].includes(p.role)));
  }, [data, userCtx]);

  const canViewMinobrReport = useMemo(() => {
    const stratPortfIds = data ? data.map((p) => p.portfId) : [];
    return isAdminReadRestricted(userCtx)
        || getStrategyPermissions(userCtx, parseInt(stratId)).canRead // команда управления СП
        || userCtx.perms.includes('portfolios')
          && stratPortfIds.find((id) => userCtx.mine.portfolios.find((p) => p.portfId === id)); // команды портфелей в этом СП
  }, [data, userCtx]);

  const fetchData = async (year) => {
    if (isLoaded) setIsLoaded(false);
    const yearQuery = year ? `year=${year}&` : '';
    const [result, approvedProjectsCount] = await Promise.all([
      api.get(`/projs/0/reports?${yearQuery}strategyId=${stratId}`),
      api.get(`/stats/projs/approved?year=${year}&strategyId=${stratId}`)
    ]);

    setIsLoaded(true);
    setData(result);
    setApprovedProjectsInCurrentYear(approvedProjectsCount);
  };
  const handleYearChange = async (val) => {
    setCurrentYear(val);
    await fetchData(val.value); // вызов обновления данных на каждую смену фильтра по годам
  };


  useEffect( () => {
    fetchData(currentYear.value);
  }, []);

  const updateProjStatus = async (id, status) => {
    await setData((prev) => prev.map((r) => (r.id === id ? { ...r, status: status } : r)));
  };

  const updateReportStatus = async (id, status) => {
    await setData((prev) => prev.map((r) => (r.id === id ? { ...r, reportStatus: status } : r)));
  };

  const handleSendForRevision = async (newComment) => {
    const sendForRevisionResp = await api.post(`/projs/${revisionModalReportId}/results/0/return`, { year: currentYear.value, comment: newComment });
    if (sendForRevisionResp.error) return;
    await updateReportStatus(revisionModalReportId, sendForRevisionResp.status);
  };

  const handleDecisionChange = (fieldName, value) => setDecision((prev) => ({ ...prev, [fieldName]: value }));
  const handleCloseDataChange = (fieldName, value) => setCloseData((prev) => ({ ...prev, [fieldName]: value }));

  const columns = [
    {
      title: 'Действ.',
      cellStyle: {
        width:'1%'
      },
      headerStyle:{
        width:'1%'
      },
      render: (rowData) =>
            <ProjRegisterDataAction
                imageProps={{imageButton:false}}
                props={rowData}
                actions={actions}
                userCtx={userCtx}
                stratId={stratId}
            />
    },
    {
      title: '№',
      field: 'fullNumber',
      filterCellStyle: { width: '7%' },
      defaultSort: 'asc',
      customSort: (a, b) => {
        const [firstNumber, secondNumber] = [a.fullNumber.toString().split('.'), b.fullNumber.toString().split('.')];
        const [stratNumberFirst, projNumberFirst] = [+firstNumber[0], +firstNumber[1]];
        const [stratNumberSecond, projNumberSecond] = [+secondNumber[0], +secondNumber[1]];
        const isAnyNaNValue = Number.isNaN(stratNumberSecond) && Number.isNaN(projNumberSecond) && Number.isNaN(stratNumberFirst) && Number.isNaN(projNumberFirst);
        return !isAnyNaNValue && ((stratNumberFirst === stratNumberSecond) && projNumberFirst - projNumberSecond);
      },
    },
    {
      title: 'Наименование проекта',
      filterCellStyle: { width: '800px' },
      field: 'name',
      render: (rowData) => <NavLink to={`/strats/${stratId}${rowData.portfId ? `/portfolios/${rowData.portfId}/projs/${rowData.id}/yearReport` : `/projs/${rowData.id}/report`}/year/${currentYear.value}`}>{rowData.name}</NavLink>,
    },
    {
      title: 'Руководитель проекта',
      field: 'head.fullName',
      lookup: filtersHead,
      customFilterAndSearch: (term, rowData) => { if (term.length < 1) return true; return term.includes(rowData.head.id); },
      render: (rowData) => rowData.head.fullName,
    },
    {
      title: `Статус отчёта ${currentYear.value}`,
      field: 'reportStatus',
      lookup: statusLabels,
      customFilterAndSearch: filterReportStatus,
      render: (rowData) => <ReportStatusBadge status={rowData.reportStatus} />,
    },
    {
      title: `Статус проекта`,
      field: 'status',
      lookup: PS_Labels,
      customFilterAndSearch: filterProjStatus,
      render: ({status}) => <StatusBadge type={'proj'} status={status}  />,
    },

    // {
    //   title: `Файлы закрытия`,
    //   field: 'reportStatus',
    //   lookup: YesLookup,
    //   customFilterAndSearch:(term, rowData)=>yseLookupFiltering(term,rowData,'file'),
    //   render: (rowData) => rowData?.proj?.decisionFiles
    //       ? <FileTableComponent data={1}
    //                             onClick={() => {
    //                               debugger
    //                               !!rowData?.proj?.decisionFiles && setFilesModalOpen(rowData.proj?.decisionFiles)
    //                             }}/>
    //       : <FileTableComponent/>,
    // },
  ];

  const getSelectedRows = ()=> !currReport ? tableRef.current.state.data?.filter(el=>!!el?.tableData?.checked).map(el=>el.id) : [currReport.id]

  const handleSaveExpertDecision = () => {
    const projIds = getSelectedRows()
    const saveOrEditPromise = !!currReport?.isEdit
        ? editExpertDecision(addToast,{year:currentYear.value,...decision},currReport.id)
        : saveExpertDecision(addToast,{projIds,year:currentYear.value,...decision})
    return saveOrEditPromise
        .then(response=>{
          projIds.forEach((el)=> updateReportStatus(el, response.status))
          return response
        })
        .then(()=> setDecision(DEFAULT_DECISION))
        .then(()=> { //модалка должна закрываться только если с сервера не пришла ошибка
          handleChangeModal();
          handleClearCheckedRows(tableRef.current);
        });
  }

  const handleCloseProj = () => {
    const projIds = getSelectedRows()
    const saveOrEditPromise = !!currReport?.isEdit
        ? editCloseDataProject(addToast,{projId:currReport.id,...closeData})
        : closeProject(addToast,{projIds,...closeData})
    return saveOrEditPromise
        .then(response=>{
          projIds.forEach((el)=>updateProjStatus(el,response.status))
          return response
        })
        .then(()=> setCloseData(DEFAULT_CLOSE_DATA))
        .then(()=> {
          handleChangeModal(); //модалка должна закрываться только если с сервера не пришла ошибка
          handleClearCheckedRows(tableRef.current);
        });
  }

  const handleGetCurrentReportDecision = (projId) =>{
    return getReportByProjId(addToast,currentYear.value,projId)
        .then(el=> {
          const respDesicion={
            mark:el.mark,
            isApproved: [RS.expertsApproved].includes(el.status),
            recommendations: el.decision,
            protocol: el.protocol,
            decisionDate: el.decisionDate,
            decisionFiles: el.decisionFiles
          }
          setDecision(respDesicion)
        })
  }

  const handleGetCurrentReportCloseData = (projId) =>{
    return getReportByProjId(addToast,currentYear.value,projId)
        .then(el=> {
          const respCloseData = {
            closedOn:el.proj.closedOn,
            closeFiles: el.proj.decisionFiles
          }
          setCloseData(respCloseData)
        })
  }

  const canCloseProj = (proj) => {
    if([PS.onApproveHeadSP,PS.onApproveExperts,PS.onApprovePortf,PS.onApproveCommittee].includes(proj.status)){
      addToast.error('Невозможно закрыть проект, так как последняя версия ЦП на согласовании')
      return false
    }
    return true
  }
  const actions = {
    // onEdit: (reportId) => history.push(`${location.pathname}/${reportId}?edit=1`),
    // onSendPortf: () => setModalName('sendPortf'),
    // onSendHeadSP: () => setModalName('sendHeadSP'),
    // onSendExperts: () => handleSendExperts(),
    // onReturnForRevisionPortf: () => setModalName('returnForRevisionPortf'),
    // onReturnForRevisionHead: () => setModalName('returnForRevisionHead'),
    // onReturnForRevisionExpert: () => setModalName('returnForRevisionExpert'),
    // onApproveExpert: () => handleExpertApprove(),
    // onApproveFinal: () => setModalName('ApproveFinal'),
    onExpertChangeDecision:(currReport) => {
      handleGetCurrentReportDecision(currReport.id)
          .then(()=>{
            handleChangeModal('expertDecision')
            setCurrReport({...currReport,isEdit:true})
          })
    },
    onExpertDecision:(currReport)=>{
      handleChangeModal('expertDecision')
      setCurrReport(currReport)
    },
    onChangeCloseProj:(currReport) => {
      handleGetCurrentReportCloseData(currReport.id)
          .then(()=>{
            handleChangeModal('closeProj')
              setCurrReport({...currReport,isEdit:true})
          })
    },
    onCloseProj:(currReport) =>{
      if(canCloseProj(currReport)) {
        handleChangeModal('closeProj')
        setCurrReport(currReport)
      }
    }
  };

  function getFilesForModal() {
    const files = filesModalOpen ?? []
    return mapFilesForModal(files,`Подтверждающие документы`)
  }
  const handleChangeModal = (name,report,isEdit) => {
    if(!!report && !currReport) {
      callbackAfterSelection(name, report, isEdit)
      return
    }
    setModalName(name ?? '')
    if(currReport!=null && !name?.length && !report) {
      setCurrReport(null);
      // чистим всё, иначе если нажать "Отмена" в модалке и попробовать одобрить/закрыть (не редактировать!) другой отчет/проект, то в модалке будут данные из предыдущей модалки
      setDecision(DEFAULT_DECISION);
      setCloseData(DEFAULT_CLOSE_DATA);
    }
  }

  const callbackAfterSelection = (name,report,isEdit) => {
      setCurrReport({...report,isEdit})
      switch (name){
        case 'expertDecision':{
          return isEdit ? actions.onExpertChangeDecision(report) : actions.onExpertDecision(report);
        }
        case 'closeProj':{
          return isEdit ? actions.onChangeCloseProj(report) : actions.onCloseProj(report)
        }
    }
  }


  const handleClearCheckedRows = (ref) => ref?.onAllSelected(false)

  const materialTable = useMemo(()=>{
    return <div style={styledTable} className={`${style.tableWrapper}`}>
      <div className="d-flex justify-content-between">
        <div className={`d-flex`}>
          <Select
              placeholder="Выберите год"
              name="yearsSingle"
              options={modifiedYears}
              onChange={handleYearChange}
              value={currentYear}
              isSearchable={false}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 100500 }) }}
            />
            {canViewReport && (
            <div style={{ marginLeft: 16 }}>
              <DownloadLink
                variant="outline-secondary"
                url={`/reports/strategies/${stratId}/projresults/report/export?year=${currentYear.value}`}
                filename={`Отчет по уник. результатам СП${stratId}.xlsx`}
              >
                Отчет по уникальным результатам
              </DownloadLink>
            </div>
            )}
            {canViewMinobrReport && (
            <div style={{ marginLeft: 16 }}>
              <DownloadLink
                variant="outline-secondary"
                url={`/projs/0/reports/export?year=${currentYear.value}&strategyId=${stratId}`}
                filename={`Отчет о реализации проектов СП${stratId} за ${currentYear.value} год от ${moment().format('DD.MM.YYYY')}.xlsx`}
              >
                Отчет о реализации проектов
              </DownloadLink>
            </div>
            )}
            <div style={{ marginLeft: 16, display: 'flex' }}>
              <p style={{ alignSelf: 'center', color: '#6c757d' }}>
                Всего отчетов: {data.length} {!!approvedProjectsInCurrentYear  && !approvedProjectsInCurrentYear?.error ? `из ${approvedProjectsInCurrentYear?.approvedProjsCount}` : '' }
              </p>
          </div>
        </div>
        <div><Button className="mb-4" size="sm" variant="outline-secondary" onClick={() => setTableKey(makeUID(5))}>Очистить фильтры</Button></div>
      </div>
      <LoadingTable loadingObject={{isLoaded}}>
        <MuiThemeProvider theme={ReportRegisterTabTheme}>
          <MaterialTable
              tableRef={tableRef}
              key={tableKey}
              options={modifyDefaultOptions({
                search: false,
                toolbar: false,
                selection: canDecide,
                selectionProps: rowData => ({ disabled: rowData.tableData.disabled }),
                maxBodyHeight: 'calc(100vh - 506px)',
              })}
              components={{

                Container: (props) => <div className={'special-filter'} {...props}/>
              }}

              actions={[
                // (rowData) => ({
                //   disabled: !canEdit(rowData.reportStatus, userCtx),
                //   icon: () => <IconEdit disabled={!canEdit(rowData.reportStatus, userCtx)}/>,
                //   tooltip: 'Редактировать',
                //   onClick: () => history.push(`/strats/${stratId}${rowData.portfId ? `/portfolios/${rowData.portfId}/projs/${rowData.id}/yearReport` : `/projs/${rowData.id}/report`}/year/${currentYear.value}`),
                // })
              ]}
              onSelectionChange={(data, rowData)=>{
                getSelectedReportsIds(data,rowData)
              }}
              icons={tableIconsModified}
              localization={localization}
              columns={columns}
              data={data.map(rowData => {
                rowData.tableData = { ...rowData.tableData, disabled: !isAdmin(userCtx) };
                return rowData;
              })}
          />
        </MuiThemeProvider>
      </LoadingTable>
    </div>
  },[currentYear,tableKey,isLoaded,data,approvedProjectsInCurrentYear])

  const getSelectedReportsIds = (data,rowData)=>{
    setSelectedRows({data:data.map(el=>el),count:data.length})
  }
  return (
    <section>
      <div style={styledTable} className={`${style.tableWrapper}`}>
        {materialTable}
      </div>
      <SelectionFab onBack={()=> handleClearCheckedRows(tableRef.current)} onModalOpen={handleChangeModal} selectedCount={selectedRows?.count} selectedReportsIds={selectedRows?.data}/>
      {<ModalDescription headerText={'Приложенные документы'} onClose={() => setFilesModalOpen(!filesModalOpen)}
                         show={filesModalOpen}>
        <Container>
          {getFilesForModal()}
        </Container>
      </ModalDescription>}
      <SendForRevisionModal show={modalName==='revisionModalReportId'} onSubmit={handleSendForRevision} onClose={() => handleChangeModal()} />
      <ModalExpertDecision  decision={decision} onDecisionChange={handleDecisionChange} show={modalName==='expertDecision'} status={currReport?.reportStatus ?? 'onApproveExperts'} onConfirm={()=>handleSaveExpertDecision().then(()=>addToast.success('Выбранные проекты оценены'))} onClose={()=>handleChangeModal()} />
      <ModalCloseProj show={modalName==='closeProj'} onClose={()=>handleChangeModal()} onConfirm={handleCloseProj} onCloseDataChange={handleCloseDataChange} onChangeFile={()=>console.log('файлы изменены')} closeData={closeData}/>
    </section>
  );
}
